import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Modal, message, Collapse } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import {
  getSSPAcademicYear,
  formateDate_YMD,
  formateDateDbT_YMD,
} from "../../utils/dateUtil";
import {
  req_list_ssp_planner_studentsource_limit_depart,
  req_delete_ssp_school_target_detail,
  req_edit_ssp_school_target_detail,
  req_list_ssp_target_principal,
  req_list_ssp_school_source_detail,
  req_list_ssp_school_source_main_academicSystem,
  req_add_school_plan_detail,
  req_downloadfile_ssp_depart_plan_detail_academicSystem,
} from "../../api";
const { Panel } = Collapse;
class StudentSourceJuniorEditList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    userLevel: "NORMAL",
    data: [],
    row: {
      Gid: "",
      YearMonth: "",
      PlanAcademicYear: "",
      AcademicSystem: "七技",
      UniversityCode: "1051",
      CollegeCode: "",
      TargetDepartmentCode: "",
      PrincipalCode: "",
      SourceCode: "",
      HighSchoolCode: "",
      SourceDepartmentCode: "",
      NumberOfPeople: 0,
      RecordCreatorId: "",
      RecordEditorId: "",
    },
    obj: {},
    colleges: [{ label: "藝術學院", value: "63" }],
    targetdeparts: [
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
    ],
    targetdepartlist: [
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
    ],
    targetprincipals: [],
    sourcehighSchools: [],
    sourcedeparts: [],
    academicSystems: [{ label: "七技", value: "七技" }],
    sourceCodes: [
      { value: "BA", label: "藝術單招(B1)" },
      { value: "BB", label: "特殊選才(B2)" },
      { value: "BC", label: "繁星入學(B3)" },
      { value: "BD", label: "運優單招(B4)" },
      { value: "BE", label: "一般獨招(B5)" },
      { value: "CA", label: "四技申請(高中生)(C)" },
      { value: "DA", label: "技優甄審(D)" },
    ],
    viewStatus: [
      { value: "NEW", label: "今日新增" },
      { value: "SELF", label: "僅限本人規劃" },
      { value: "ALL", label: "所有數據" },
    ],
    selectedCountyCityName: "NONE",
    selectedCollege: "63",
    selectedTargetdepart: "NONE",
    selectedAcademicSystem: "七技",
    selectedTargetprincipal: "NONE",
    selectedSourceCode: "AN",
    selectedHighSchoolCode: "NONE",
    selectedSourceDepartmentCode: "000",
    selectedViewStatus: "NEW",
    canEndable: false,
    todayYMD: formateDate_YMD(new Date()),
  };

  componentWillMount() {
    this.api_list_target_depart();
    this.api_list_studentsource();
  }

  //////////
  api_list_target_depart = () => {
    const { selectedCollege } = this.state;
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === selectedCollege;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  api_list_target_principal = async (targetDepart) => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_ssp_target_principal(
      userCode,
      userLevel,
      targetDepart,
      token
    );
    const targetprincipals = result.total > 0 ? result.data : [];
    this.setState({ targetprincipals });
    // console.log("targetprincipals:", targetprincipals);
  };

  api_list_source_highSchool = async () => {
    const { planAcademicYear, selectedCountyCityName } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_source_main_academicSystem(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCountyCityName,
      "國中",
      token
    );
    const sourcehighSchools = result.total > 0 ? result.data : [];
    this.setState({ sourcehighSchools });
  };

  api_list_source_depart = async () => {
    const { planAcademicYear, selectedHighSchoolCode } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_source_detail(
      userCode,
      userLevel,
      planAcademicYear,
      selectedHighSchoolCode,
      token
    );
    const sourcedeparts = result.total > 0 ? result.data : [];
    this.setState({ sourcedeparts });
  };

  api_list_studentsource = async () => {
    const {
      planAcademicYear,
      selectedAcademicSystem,
      selectedViewStatus,
      selectedTargetdepart,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [], loading: true });
    const result = await req_list_ssp_planner_studentsource_limit_depart(
      userCode,
      userLevel,
      planAcademicYear,
      selectedAcademicSystem,
      selectedViewStatus,
      selectedTargetdepart,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
    } else {
      const items = [];
      this.setState({ data: items, loading: false });
    }
  };

  api_list_studentsource_noloading = async () => {
    const {
      planAcademicYear,
      selectedAcademicSystem,
      selectedViewStatus,
      selectedTargetdepart,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [] });
    const result = await req_list_ssp_planner_studentsource_limit_depart(
      userCode,
      userLevel,
      planAcademicYear,
      selectedAcademicSystem,
      selectedViewStatus,
      selectedTargetdepart,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      const items = [];
      this.setState({ data: items });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_ssp_school_target_detail(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  api_edit_item = async (row) => {
    const { token, userCode } = this.props.user;
    row.RecordEditorId = userCode;
    await req_edit_ssp_school_target_detail(row, token);
    this.handle_data_refresh();
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_school_plan_detail(item, token);
    if (result.status === "success") {
      // console.log(result)
      this.handle_data_refresh();
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, planAcademicYear, selectedTargetdepart } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl =
      await req_downloadfile_ssp_depart_plan_detail_academicSystem(
        userCode,
        userLevel,
        planAcademicYear,
        selectedTargetdepart,
        "七技",
        token
      );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  setTargetdeparts = () => {
    this.api_list_target_depart();
  };

  setTargetprincipals = (value) => {
    this.api_list_target_principal(value);
  };

  //////////
  handle_data_refresh = () => {
    this.api_list_studentsource();
    // console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    //  console.log("handle_show_ui_modal");
    const { Gid } = item;
    switch (modal) {
      case "add":
        this.handle_data_refresh();
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆生源規劃`,
          onOk: () => {
            this.api_delete_item(Gid);
          },
        });
        break;
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const { userCode } = this.props.user;
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        Gid: target_key,
        NumberOfPeople: getValue,
        RecordEditorId: userCode,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_edit_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  //////////
  handleChange = (event) => {
    const { row } = this.state;
    Object.keys(row).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        row[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ row });
    // console.log("handleChange", row);
  };

  handleCollegeChange = (event) => {
    this.setState({
      selectedTargetdepart: "NONE",
      selectedTargetprincipal: "NONE",
    });
    this.setTargetdeparts();
    //console.log(value);
  };

  handleTargetdepartChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedTargetdepart: value,
        selectedTargetprincipal: "NONE",
      },
      () => {
        this.api_list_studentsource_noloading();
      }
    );
    //console.log(value);
    this.setTargetprincipals(value);
  };

  handleTargetprincipalChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedTargetprincipal: value,
    });
  };

  handleViewStatusChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedViewStatus: value,
      },
      () => {
        this.handle_data_refresh();
      }
    );
  };
  handleselectedCountyCityNameChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedCountyCityName: value,
        selectedHighSchoolCode: "NONE",
      },
      () => {
        this.api_list_source_highSchool();
      }
    );
  };

  handleHighSchoolCodeChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedHighSchoolCode: value,
    });
  };

  handleSourceCodeChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedSourceCode: value,
    });
  };

  handleNumberOfPeople = (event) => {
    const value = event.target.value;
    this.setState({
      setNumberOfPeople: value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const {
      planAcademicYear,
      selectedCollege,
      selectedTargetdepart,
      selectedTargetprincipal,
      selectedAcademicSystem,
      selectedSourceCode,
      selectedHighSchoolCode,
      selectedSourceDepartmentCode,
    } = this.state;

    const errors = [];

    if (selectedCollege === "NONE") {
      errors.push("規劃學院未選");
    }

    if (selectedTargetdepart === "NONE") {
      errors.push("規劃系所未選");
    }

    if (selectedTargetprincipal === "NONE") {
      errors.push("負責人未選");
    }

    if (selectedAcademicSystem === "NONE") {
      errors.push("招收學制未選");
    }

    if (selectedSourceCode === "NONE") {
      errors.push("招收方式未選");
    }
    if (selectedHighSchoolCode === "NONE") {
      errors.push("生源學校未選");
    }

    const row = this.state.row;
    if (row.NumberOfPeople === 0) {
      errors.push("規劃員額不能少於一人");
    }

    if (errors.length === 0) {
      const { userCode } = this.props.user;
      row.PlanAcademicYear = planAcademicYear;
      row.CollegeCode = selectedCollege;
      row.AcademicSystem = selectedAcademicSystem;
      row.TargetDepartmentCode = selectedTargetdepart;
      row.PrincipalCode = selectedTargetprincipal;
      row.SourceCode = selectedSourceCode;
      row.HighSchoolCode = selectedHighSchoolCode;
      row.SourceDepartmentCode = selectedSourceDepartmentCode;
      row.RecordEditorId = userCode;
      row.RecordCreatorId = userCode;
      console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  };

  render() {
    const {
      planAcademicYear,
      data,
      loading,
      academicSystems,
      colleges,
      targetdepartlist,
      targetprincipals,
      sourcehighSchools,
      sourceCodes,
      selectedAcademicSystem,
      selectedCollege,
      selectedTargetdepart,
      selectedTargetprincipal,
      selectedCountyCityName,
      selectedHighSchoolCode,
      selectedSourceCode,
      todayYMD,
      viewStatus,
      selectedViewStatus,
    } = this.state;
    const { NumberOfPeople } = this.state.row;
    const columns = [
      {
        title: "",
        width: "50px",
        render: (item) => {
          return (
            <>
              <button
                className="btn btn-dark btn-sm"
                style={{ width: "82px" }}
                onClick={() => this.handle_show_ui_modal("delete", item)}
              >
                <i className="fas fa-trash-alt"></i> 刪除
              </button>
            </>
          );
        },
      },
      {
        title: "學制",
        align: "center",
        dataIndex: "AcademicSystem",
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
      },
      {
        title: "系所",
        dataIndex: "TargetDepartmentName",
      },
      {
        title: "負責人",
        align: "center",
        dataIndex: "TwName",
      },
      {
        title: "招生管道",
        align: "center",
        dataIndex: "SourceName",
      },
      {
        title: "來源學校",
        dataIndex: "HighSchoolTwName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#FFFFA0"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "來源科班",
        dataIndex: "HighSchoolDepartmentName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#FFFFA0"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "規劃員額",
        width: "50px",
        align: "right",
        fixed: "true",
        render: (item) => {
          const { NumberOfPeople, Gid } = item;
          return (
            <>
              <Input
                type="number"
                placeholder="人數"
                style={{ width: "60px", backgroundColor: "LightYellow" }}
                defaultValue={NumberOfPeople}
                onChange={(e) => this.handle_ui_field_change(Gid, "QUOTA", e)}
              />
            </>
          );
        },
      },
    ];

    return (
      <>
        <div>
          <div
            style={{
              display: "inline-block",
            }}
          >
            <div className="form-group">
              <Input
                placeholder="規劃年度"
                style={{
                  width: 55,
                  height: 39,
                  margin: "0 5px",
                  color: "red",
                }}
                onChange={(event) =>
                  this.setState({ planAcademicYear: event.target.value })
                }
                value={planAcademicYear}
                readOnly={true}
                disabled={true}
              />
              <select
                className="form-control"
                style={{
                  width: "180px",
                  backgroundColor: "#FDEDEC",
                  display: "inline-block",
                }}
                onChange={this.handleViewStatusChange}
                value={selectedViewStatus}
              >
                {viewStatus.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{ width: "80px", display: "inline-block" }}
                onChange={this.handleAcademicSystem}
                value={selectedAcademicSystem}
              >
                <option key={"NONE"} value={"NONE"}>
                  請選擇學制
                </option>
                {academicSystems.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{ width: "160px", display: "inline-block" }}
                onChange={this.handleCollegeChange}
                value={selectedCollege}
              >
                {colleges.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{
                  width: "180px",
                  display: "inline-block",
                  backgroundColor: "LightCyan",
                }}
                onChange={this.handleTargetdepartChange}
                value={selectedTargetdepart}
              >
                <option key={"NONE"} value={"NONE"}>
                  請選擇系所
                </option>
                {targetdepartlist.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <button
                className="btn btn-info"
                onClick={this.handle_data_refresh}
                style={{
                  marginLeft: "2px",
                  marginBottom: "6px",
                  display: "inline-block",
                }}
              >
                <i className="fas fa-sync-alt"></i>
              </button>
              <button
                className="btn btn-info"
                onClick={() => this.handle_show_ui_modal("download", {})}
                style={{ marginBottom: "6px", marginLeft: "2px" }}
              >
                <i className="fas fa-cloud-download-alt"></i>
              </button>
              <br></br>
              <Collapse>
                <Panel header="新增單筆" key="1">
                  <>
                    <form onSubmit={this.handleSubmit}>
                      <select
                        className="form-control"
                        style={{
                          width: "160px",
                          display: "inline-block",
                          backgroundColor: "LightCyan",
                        }}
                        onChange={this.handleSourceCodeChange}
                        value={selectedSourceCode}
                      >
                        <option key={"NONE"} value={"NONE"}>
                          招收方式
                        </option>
                        {sourceCodes.length > 0 ? (
                          <>
                            {sourceCodes.map((item) => (
                              <option key={item.value} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </select>
                      <select
                        className="form-control"
                        style={{
                          width: "160px",
                          display: "inline-block",
                          backgroundColor: "LightCyan",
                        }}
                        onChange={this.handleTargetprincipalChange}
                        value={selectedTargetprincipal}
                      >
                        <option key={"NONE"} value={"NONE"}>
                          請選擇負責人
                        </option>
                        {targetprincipals.length > 0 ? (
                          <>
                            {targetprincipals.map((item) => (
                              <option
                                key={item.EmployeeId}
                                value={item.EmployeeId}
                              >
                                {item.EmployeeId}-{item.TwName}
                              </option>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </select>
                      <select
                        className="form-control"
                        style={{
                          width: 120,
                          backgroundColor: "LightCyan",
                          display: "inline-block",
                        }}
                        onChange={this.handleselectedCountyCityNameChange}
                        value={selectedCountyCityName}
                      >
                        <option key="NONE" value="NONE">
                          生源縣市
                        </option>
                        <option value="臺北市" key="臺北市">
                          臺北市
                        </option>
                        <option value="新北市" key="新北市">
                          新北市
                        </option>
                        <option value="基隆市" key="基隆市">
                          基隆市
                        </option>
                        <option value="宜蘭縣" key="宜蘭縣">
                          宜蘭縣
                        </option>
                        <option value="花蓮縣" key="花蓮縣">
                          花蓮縣
                        </option>
                        <option value="臺東縣" key="臺東縣">
                          臺東縣
                        </option>
                        <option value="桃園市" key="桃園市">
                          桃園市
                        </option>
                        <option value="新竹市" key="新竹市">
                          新竹市
                        </option>
                        <option value="新竹縣" key="新竹縣">
                          新竹縣
                        </option>
                        <option value="苗栗縣" key="苗栗縣">
                          苗栗縣
                        </option>
                        <option value="臺中市" key="臺中市">
                          臺中市
                        </option>
                        <option value="彰化縣" key="彰化縣">
                          彰化縣
                        </option>
                        <option value="南投縣" key="南投縣">
                          南投縣
                        </option>
                        <option value="雲林縣" key="雲林縣">
                          雲林縣
                        </option>
                        <option value="嘉義市" key="嘉義市">
                          嘉義市
                        </option>
                        <option value="嘉義縣" key="嘉義縣">
                          嘉義縣
                        </option>
                        <option value="臺南市" key="臺南市">
                          臺南市
                        </option>
                        <option value="高雄市" key="高雄市">
                          高雄市
                        </option>
                        <option value="屏東縣" key="屏東縣">
                          屏東縣
                        </option>
                        <option value="金門縣" key="金門縣">
                          金門縣
                        </option>
                        <option value="連江縣" key="連江縣">
                          連江縣
                        </option>
                        <option value="澎湖縣" key="澎湖縣">
                          澎湖縣
                        </option>
                      </select>
                      <select
                        className="form-control"
                        style={{
                          width: "200px",
                          display: "inline-block",
                          backgroundColor: "LightCyan",
                        }}
                        onChange={this.handleHighSchoolCodeChange}
                        value={selectedHighSchoolCode}
                      >
                        <option key={"NONE"} value={"NONE"}>
                          生源學校
                        </option>
                        {sourcehighSchools.length > 0 ? (
                          <>
                            {sourcehighSchools.map((item) => (
                              <option
                                key={item.HighSchoolCode}
                                value={item.HighSchoolCode}
                              >
                                {item.HighSchoolTwName}
                              </option>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </select>
                      <input
                        type="number"
                        className="form-control"
                        style={{
                          width: "60px",
                          backgroundColor: "LightYellow",
                          display: "inline-block",
                        }}
                        name="NumberOfPeople"
                        id="NumberOfPeople"
                        defaultValue={NumberOfPeople}
                        placeholder="請輸人數"
                        onChange={this.handleChange}
                      />
                      <button
                        type="submit"
                        className="btn btn-info"
                        style={{
                          marginLeft: "2px",
                          marginBottom: "6px",
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </form>
                  </>
                </Panel>
              </Collapse>
            </div>
          </div>

          <Table
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            loading={loading}
          />
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentSourceJuniorEditList);
